<template>
  <!-- Footer -->
  <footer id="page-footer" class="page-footer font-small mdb-color pt-4y z10 pt-4" style="color: #495057; background-color: #f7f5fa">
    <!-- Footer Links -->
    <div class="container text-center text-md-left pt-4">
      <!-- Footer links -->
      <div class="row text-center text-md-left mt-3 pb-3">
        <!-- Grid column -->
        <div class="col-md-3 col-lg-3 mx-auto pr-3">
          <img :src="logoSrc" class="" style="max-width: 150px" />
          <p class="pr-5 text-gray-500 mt-3">
            {{ $t('general.footer.text-description') }}
          </p>
        </div>
        <!-- Grid column -->

        <hr class="w-100 clearfix d-md-none" />

        <!-- Grid column -->
        <div class="col-md-2 col-lg-2 col-xl-2 mx-auto mt-3 text-gray-500">
          <h6 style="color: #495057" v-if="currentRouteName != 'OrganizationSelection'" class="text-uppercase mb-4 tex-uppercase font-weight-normal">
            {{ $t('general.footer.plataform') }}
          </h6>

          <ul class="m-0 p-0" v-if="currentRouteName != 'OrganizationSelection'">
            <li class="mb-2">
              <router-link class="linkNav" :to="{ name: 'audience' }">
                {{ $t('general.header.dropdownItems.audience') }}
              </router-link>
            </li>
            <li class="mb-2">
              <router-link class="linkNav" :to="{ name: 'campaignList' }">
                {{ $t('sender.domainSender.domainSenderList.status.campaignList') }}
              </router-link>
            </li>
            <!--<li class="mb-2">
              <router-link class="linkNav font-sm" :to="{ name: 'automation' }">
                {{ $t('general.header.navs.automation') }}
              </router-link>
            </li>-->
            <li class="mb-2">
              <router-link class="linkNav" :to="{ name: 'template-emails' }">
                {{ $t('general.header.navs.emailTemplate') }}
              </router-link>
            </li>
            <!-- <li class="mb-2">
              <router-link class="linkNav font-sm" :to="{ name: 'template-sms' }">
                {{ $t('general.header.navs.smsTemplate') }}
              </router-link>
            </li> -->
          </ul>
        </div>
        <!-- Grid column -->

        <hr class="w-100 clearfix d-md-none" />

        <!-- Grid column -->
        <div class="col-md-2 col-lg-2 col-xl-2 mx-auto mt-3">
          <h6 v-if="currentRouteName != 'OrganizationSelection'" class="text-uppercase mb-4 font-weight-normal">
            {{ $t('general.footer.company') }}
          </h6>

          <ul class="m-0 p-0" v-if="currentRouteName != 'OrganizationSelection'">
            <li v-if="!$store.getters['whitelabel/isWhitelabel']" class="mb-2">
              <router-link class="linkNav" :to="{ name: 'home' }">
                {{ $t('general.header.dropdownItems.plataform') }}
              </router-link>
            </li>
            <li v-if="!$store.getters['whitelabel/isWhitelabel']" class="mb-2">
              <a class="aboutUs" href="https://sendit.pt" target="_blank">{{ $t('general.header.dropdownItems.abountUs') }}</a>
            </li>
            <li class="mb-2">
              <router-link class="linkNav" :to="{ name: 'help' }">
                {{ $t('general.header.navs.help') }}
              </router-link>
            </li>
          </ul>
        </div>

        <!-- Grid column -->
        <hr class="w-100 clearfix d-md-none" />

        <!-- Grid column -->
        <div class="col-md-2 col-lg-2 col-xl-2 mx-auto mt-3">
          <h6 class="text-uppercase mb-4 font-weight-normal">{{ $t('general.footer.choose-language') }}</h6>

          <ul class="list-unstyled list-inline mt-3">
            <li class="list-inline-item mx-2">
              <span
                :class="{ linkSocialSelected: currentLang == 'en-US' }"
                class="span-hover text-capitalize linkSocial font-sm p-2 border-1"
                v-c-emit-root-event:chooseLang="'en-US'"
                >{{ $t('general.footer.english') }}</span
              >
            </li>
            <li class="list-inline-item mx-2">
              <span
                :class="{ linkSocialSelected: currentLang == 'pt-PT' }"
                class="span-hover text-capitalize linkSocial font-sm p-2 border-1"
                v-c-emit-root-event:chooseLang="'pt-PT'"
                >{{ $t('general.footer.portuguese') }}</span
              >
            </li>
          </ul>
        </div>
        <!-- Grid column -->

        <!-- Grid column -->
        <div class="col-md-2 col-lg-2 col-xl-2 mx-auto mt-3" v-if="!$store.getters['whitelabel/isWhitelabel']">
          <h6 class="text-uppercase mb-4 font-weight-normal">{{ $t('general.footer.connect-with-us') }}</h6>

          <ul class="list-unstyled list-inline mt-3">
            <li class="list-inline-item">
              <a title="facebook" class="btn-floating rgba-white-slight mx-1" href="https://www.facebook.com/SenditPortugal/" target="_blank">
                <CIcon name="facebook" class="text-gray-600" :height="22" viewBox="0 0 32 32" />
              </a>
            </li>
            <li class="list-inline-item">
              <a
                title="linkedin"
                class="btn-floating rgba-white-slight mx-1"
                href="https://www.linkedin.com/company/senditdigitalcommunication/"
                target="_blank"
              >
                <CIcon name="cibLinkedin" class="text-gray-600" :height="22" viewBox="0 0 32 32" />
              </a>
            </li>
          </ul>
        </div>
        <!-- Grid column -->
      </div>
      <!-- Footer links -->

      <!-- Grid row -->
      <div class="row d-flex justify-content-between py-2 mt-5">
        <!-- Grid column -->
        <div class="col d-flex justify-content-start">
          <!--Copyright-->
          <p class="text-center text-md-center">
            <a href="https://sendit.pt" class="text-gray-500" target="_blank">Sendit © {{ year }} {{ $t('general.footer.copyright') }} </a>
          </p>
        </div>
        <div v-if="currentRouteName != 'OrganizationSelection'" class="col d-flex justify-content-end">
          <!--Copyright-->
          <router-link :to="{ name: 'privacy-policy' }" class="text-gray-500 mx-2">
            {{ $t('general.footer.privacy-policy') }}
          </router-link>
          |
          <router-link :to="{ name: 'terms-and-conditions' }" class="text-gray-500 mx-2">
            {{ $t('general.footer.terms-conditions') }}
          </router-link>
        </div>
        <div v-if="currentRouteName == 'OrganizationSelection'" class="col d-flex justify-content-end">
          <!--Copyright-->
          <div class="text-gray-500 mx-2 cursorPointer">{{ $t('general.footer.privacy-policy') }}</div>
          |
          <div class="text-gray-500 mx-2 cursorPointer">{{ $t('general.footer.terms-conditions') }}</div>
        </div>
        <!-- Grid column -->
      </div>
      <!-- Grid row -->
    </div>
    <!-- Footer Links -->
  </footer>
  <!-- Footer -->
</template>

<script>
export default {
  name: 'TheFooter',
  data() {
    return {
      year: '2020',
    }
  },
  mounted() {
    this.year = new Date().getFullYear()
  },
  computed: {
    currentRouteName() {
      return this.$route.name
    },

    currentLang() {
      return this.$store.state.lang
    },
    logoSrc() {
      return this.$store.state.whitelabel.whitelabelConfig?.logoUrl ?? '/img/logo-color.png'
    },
  },
}
</script>

<style lang="scss">
.span-hover {
  cursor: pointer;
}

.span-hover,
.linkNav {
  color: #868e96;
}
.span-hover:hover,
.linkNav:hover {
  text-decoration: none;
  color: #495057;
}

.linkSocial {
  text-align: center;
  width: 32px;
  height: 32px;
  display: block;
  padding: 0 !important;
  border-radius: 100em !important;
  line-height: 32px;
  &:hover {
    border-color: var(--white);
  }
}

.linkSocialSelected {
  text-align: center;
  width: 32px;
  height: 32px;
  display: block;
  padding: 0 !important;
  border-radius: 100em !important;
  line-height: 32px;
  background-color: #e8e0f0;
  &:hover {
    border-color: var(--white);
  }
}

.aboutUs {
  color: #868e96;
}

.aboutUs:hover {
  color: #495057;
}

.cursorPointer {
  cursor: pointer;
}
</style>
